<form class="flex flex-col" [formGroup]="form">
  <div class="flex flex-row gap-2">
    <mat-form-field class="flex-1">
      <mat-label data-test-id="users-filter-search-label">Search</mat-label>
      <input matInput formControlName="search" data-test-id="users-filter-search" />
    </mat-form-field>
    <button
      mat-icon-button
      class="edit"
      data-test-id="users-filter-toggle-additional-filters"
      [matTooltip]="`${showAdditionalFilters ? 'Hide' : 'Show'} additional filters`"
      (click)="toggleAdditionalFilters()"
    >
      <mat-icon>{{ showAdditionalFilters ? 'filter_alt_off' : 'filter_alt' }}</mat-icon>
    </button>
  </div>

  @if (showAdditionalFilters) {
    <mat-form-field data-test-id="users-filter-clients">
      <mat-label data-test-id="users-filter-clients-label">Clients</mat-label>
      <mat-select multiple formControlName="clientIds" data-test-id="users-filter-clients-input">
        @for (client of clients; track client.clientId) {
          <mat-option data-test-id="users-filter-clients-option" [value]="client.clientId">
            {{ client.clientName }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field data-test-id="users-filter-groups">
      <mat-label data-test-id="users-filter-groups-label">Groups</mat-label>
      <mat-select multiple formControlName="groupIds" data-test-id="users-filter-groups-input">
        @for (group of groupOptions; track group.user_group_id) {
          <mat-option data-test-id="users-filter-groups-option" [value]="group.user_group_id">
            {{ group.key | userGroup }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field data-test-id="users-filter-status">
      <mat-label data-test-id="users-filter-status-label">Status</mat-label>
      <mat-select formControlName="status" data-test-id="users-filter-status-input">
        @for (status of userStatuses; track status) {
          <mat-option data-test-id="users-filter-status-option" [value]="status">
            {{ status | sentenceCase }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  }
</form>
